import React from "react";
import BackButton from "../common/ui/backbutton";
import Pagetitle from "../common/ui/pagetitle";
import Breadcrumb from "../common/ui/breadcrumb";

/* ------------------ Header for Add In-Bond Page ------------------- */
export default function AddInBondHeader() {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-4">
      {/* Left side: Back button + Breadcrumb */}
      <div className="flex items-center gap-10 flex-wrap">
        <BackButton to="/in-bond" />
        <Breadcrumb />
      </div>

      {/* Right side: Page Title */}
      <Pagetitle title="Add In-Bond" />
    </div>
  );
}
